import React from 'react'
import { useNavigate } from 'react-router';

function StartedWith({ heading, content1, content2, button1, button2, btn1OnClick, btn2OnClick }) {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
    const navigate = useNavigate()

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <div className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat" >
            <div className="flex flex-col bg-[#EB7E0E] w-full rounded-[24px] min-h-[180px] p-10">
                <h5 className={`text-white ${isMobile ? "text-[1.3rem]" : "text-[2rem]"} font-[600] mb-3`}>{heading ? heading : "Get Started with Nirantara ESG"}</h5>
                {content1 ? <p className='text-white font-[500] mb-3 whitespace-pre-line'>{content1 ? content1 : `Contact us to Explore how we can co-create a\n
                    sustainable blueprint tailored to your organization’s ESG ambitions.`}</p> : null}
                {content2 ? <p className='text-white font-[500] mb-3'>{content2 ? content2 : "Nirantara: where responsibility meets opportunity."}
                </p> : null}
                <div className='flex flex-row justify-start gap-5'>
                    {button1 ? <button onClick={btn1OnClick ? btn1OnClick : () => navigate("/contact-us")
                    } className='px-6 py-3 bg-white text-[#EB7E0E] rounded-[8px] text-[14px] font-[600] border-2 border-[#EB7E0E]'>{button1 || "Book a Free Demo"}</button> : null}
                    {button2 ? <button onClick={btn2OnClick ? btn2OnClick : () => navigate("/contact-us")} className='px-6 py-3 bg-white text-[#EB7E0E] rounded-[8px] text-[14px] font-[600]'>{button2 || "Talk to Our Experts"}</button> : null}
                </div>
            </div>
        </div >
    )
}

export default StartedWith